<div *ngIf="visible" class="basket-button-container">
  <a id="basket" type="button" (click)="onClick()">
    <i [attr.class]="'fa fa-shopping-cart'"></i>
  </a>
  <span *ngIf="count" class="btn-warning count">{{ count }}</span>
</div>